/**
 * Les mesures de `<LiveTwinStrip>` que la scène lit pour la poser au-dessus de ma vignette sans rien
 * cacher (`organisms/LiveStage/stageLayout.ts`). Pures : elles se lisent sous Jest.
 */

/** La ligne « Aussi connecté », en petit, au-dessus des cases. */
export const TWIN_LABEL = 16
/** La rangée des cases, une par appareil. */
export const TWIN_CELLS = 36
